import { SEO } from "@/components/common/SEO";
import { Hero } from "@/components/sections/Hero";
import { BriefIntro } from "@/components/sections/BriefIntro";
import { WhoWeServe } from "@/components/sections/WhoWeServe";
import { CTABand } from "@/components/sections/CTABand";

export default function Home() {
  return (
    <>
      <SEO title="Bridging Patient Care and Research" path="/" />
      <Hero />
      <BriefIntro />
      <WhoWeServe />
      <CTABand
        title="Ready to bridge patient care and clinical research?"
        description="Partner with MedCore Research to bring clinical trials to your practice or to find and support suitable clinical sites."
        buttonLabel="Partner With MedCore"
      />
    </>
  );
}
